import { makeStyles, Theme } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  uploadButton: {
    marginBottom: 20,
  },
  urlInput: {
    height: 35,
    width: 120,
    borderWidth: 2,
    borderColor: "#b1b1b1",
    borderRadius: 8,
    paddingLeft: 10,
  },
  marginTop8: {
    marginTop: 8,
  },
  marginTop10: {
    // marginTop:5
  },
  marginTop25: {
    marginTop: 25,
  },
  marginTop15: {
    marginTop: 15,
  },
  marginRight10: {
    marginRight: 10,
  },
  GroupSelect: {
    minWidth: "100%",
    minHeight: 30,
  },
  marginBottom10: {
    marginBottom: 10,
  },
  selectCheck: {
    width: 250,
  },
  copyImage: { width: 16, height: 16, },
  root: {
    cursor: "pointer",
    textAlign: "center",
    display: "flex",
    "&:hover p,&:hover svg,& img": {
      opacity: 1,
    },
    "& p, svg": {
      opacity: 0.4,
    },
    "&:hover img": {
      opacity: 0.3,
    },
  },
  noMouseEvent: {
    pointerEvents: "none",
  },
  iconText: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    marginTop: 60,
  },
  hidden: {
    display: "none",
  },
  onDragOver: {
    "& img": {
      opacity: 0.3,
    },
    "& p, svg": {
      opacity: 1,
    },
  },
  successIcon: {
    color: "green",
    marginLeft: 20,
  },
  container: {
    border: "1px solid #C4122F",
    display: "inline-flex",
    borderRadius: 5,
    //padding:8,
    height: 38,
    color: "#C4122F",
    fontSize: 18,
    fontWeight: "initial",
    textAlign: "center",
    paddingTop: 7,
  },
  urlHttp: {
    backgroundColor: "#DBDBDB",
    height: 34,
    padding: 5,
  },
  total: { marginLeft: 15, paddingTop: 12, fontWeight: "bold" },
  input: {
    display: "none",
  },
  customFileUpload: {
    border: "2px solid #ccc",
    display: "flex",
    padding: " 4px 9px",
    cursor: "pointer",
    width: 180,
    borderRadius: 5,
    justifyContent: "center",
    marginTop: 5,
    "&:hover": {
      border: "2px solid #C4122F",
    },
  },
  downloadpdf: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  label: {
    fontSize: 16,
    paddingTop: 22,
  },
  select: {
    width: 250,
  },
  dragButton: {
    width: "22.5rem",
    paddingTop: 15,
    fontSize: "0.875rem",
  },
  dragsButton: {
    paddingTop: "1.5rem",
  },
  dargContainer: {
    borderStyle: "dashed",
    width: "97%",
    display: "flex",
    justifyContent: "center",
    height: "9.5rem",
  },
  subHeading: {
    fontSize: "0.875rem",
  },
  restrict: {
    display: "flex",
    justifyContent: " center",
    alignItems: " center",
    gap: "4px",
  },
  restrictIcon: {
    display: "flex",
    justifyContent: " center",
    alignItems: " center",
  },
  chackBox: {
    color: "#c4122f",
    fontSize: 13,
  },
  treeDropDown: {
    width: "100%",
    height: 38,
    backgroundColor: "#ffff",
    border: "2px solid #BDBDBD!important",
    marginTop: 5,
    "&:hover": {
      "&:hover": {
        borderColor: "#c4122f!important",
        borderBottomWidth: 2,
      },
    },
  },
  skip: {
    cursor: 'pointer',
    color: "#c4122f"
  },
  textbtn: {
    cursor: 'pointer',
    "&:hover": {
      color: "#c4122f"
    }
  },
  selected:{
    color: "#c4122f"
  },
  documentquestion:{
    display:"flex",
    alignItems:'center',
    gap:'10px',
    fontSize:'16px'
  }
}));
